module.exports = __webpack_public_path__ + "img/online-course-purple.8abad234.svg";